import { render } from "./LabelingConfig.vue?vue&type=template&id=495330d2&scoped=true&ts=true"
import script from "./LabelingConfig.vue?vue&type=script&lang=ts"
export * from "./LabelingConfig.vue?vue&type=script&lang=ts"

import "./LabelingConfig.vue?vue&type=style&index=0&id=495330d2&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495330d2"]])

export default __exports__